export default "__VITE_ASSET__D77k79V2__"